import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

function CTASection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const scrollToSchedule = () => {
    const el = document.getElementById("schedule");
    el?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleScheduleClick = (e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) {
      return;
    }
    e.preventDefault();
    navigate("/");
    window.setTimeout(scrollToSchedule, 200);
  };

  return (
    <section
      className="relative z-10 bg-slate-50/50 pb-14 pt-12 transition-colors dark:bg-slate-900 md:pb-16 md:pt-14"
      id="cta-section"
      aria-labelledby="taolu-cta-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <header className="mb-10 text-center md:mb-12">
          <h2
            id="taolu-cta-heading"
            className="relative mb-5 inline-block text-4xl font-semibold tracking-tight text-primary dark:text-primary-light md:text-5xl"
          >
            {t("taolu_cta.title")}
            <span
              className="absolute -bottom-2.5 left-1/2 h-0.5 w-16 -translate-x-1/2 rounded-full bg-primary dark:bg-primary-light"
              aria-hidden
            />
          </h2>
        </header>

        <div className="mx-auto max-w-3xl">
          <p className="mb-10 text-pretty text-center text-lg leading-relaxed text-slate-600 dark:text-slate-400">
            {t("taolu_cta.text")}
          </p>

          <div className="flex flex-col gap-4 sm:flex-row sm:justify-center sm:gap-5">
            <Link
              to="/"
              onClick={handleScheduleClick}
              className="inline-flex min-h-[3rem] flex-1 items-center justify-center gap-2 rounded-xl border border-transparent bg-primary px-6 py-3 text-center text-sm font-medium text-white shadow-sm transition-colors hover:bg-primary-dark dark:bg-primary-light dark:text-slate-900 dark:hover:bg-primary sm:flex-initial sm:min-w-[12rem] md:px-7 md:text-base focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-2 dark:focus-visible:ring-primary-light/50 dark:focus-visible:ring-offset-slate-900"
              aria-label={t("taolu_cta.schedule_link_aria")}
            >
              <i className="fas fa-calendar-alt text-base opacity-90" aria-hidden />
              {t("taolu_cta.button_schedule")}
            </Link>
            <a
              href="https://arena-bernau.de/de"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-[3rem] flex-1 items-center justify-center gap-2 rounded-xl border-2 border-primary bg-white px-6 py-3 text-center text-sm font-medium text-primary shadow-sm transition-colors hover:bg-primary/5 dark:border-primary-light dark:bg-slate-800 dark:text-primary-light dark:hover:bg-primary-light/10 sm:flex-initial sm:min-w-[12rem] md:px-7 md:text-base focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2 dark:focus-visible:ring-primary-light/40 dark:focus-visible:ring-offset-slate-900"
              aria-label={t("taolu_cta.tickets_link_aria")}
            >
              {t("taolu_cta.button_tickets")}
              <i className="fas fa-external-link-alt text-xs opacity-80" aria-hidden />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CTASection;
